import { mutationTypes } from '@/core/constants'

export default {
	[mutationTypes.FLOWBEE.SET_HTTP_HEADER](state, httpHeader) {
		state.pub.httpHeader = httpHeader
	},
}
